/* istanbul ignore file */

const asapCrnLogoMobile = (
  <svg
    width="74"
    height="32"
    viewBox="0 0 74 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>CRN Logo Mobile</title>
    <path
      d="M0 16.3794C0 10.6137 4.26248 4.14794 11.3083 4.14794C14.1246 4.12813 16.9101 4.7354 19.4626 5.92569C19.3219 9.39539 18.9409 11.1869 18.0486 13.0607H14.9599C14.2735 10.5073 14.4485 10.9157 13.7038 8.94237C12.8714 8.7746 12.0235 8.69637 11.1744 8.709C10.1895 8.709 8.92307 8.89776 8.50095 9.41255C7.56402 10.5828 6.90852 12.8788 6.90852 15.1302C6.90852 18.4557 8.21953 23.0511 12.5781 23.0511C14.4073 23.0511 16.0924 22.5809 18.7556 21.4553C19.5038 22.1417 19.8333 23.0511 19.974 24.3621C17.7123 26.2188 13.872 28 10.4503 28C3.14024 28 0 22.8933 0 16.3794Z"
      fill="url(#paint0_linear_582_18057)"
    />
    <path
      d="M46.2287 24.2519C47.242 24.0728 48.2376 23.8052 49.2042 23.4523C49.3338 22.5844 49.3969 21.7078 49.393 20.8303V9.34012C48.1838 8.97912 46.9443 8.7287 45.6899 8.59195C45.3495 7.67782 45.2839 6.68409 45.5011 5.73314C48.2849 4.77726 51.1869 4.20909 54.1256 4.04462L54.8738 4.4187C55.1781 5.13849 55.4439 5.87397 55.67 6.62201C57.5919 5.12225 59.8879 4 62.8428 4C66.4017 4 70.1974 6.24793 70.1974 11.3101V19.8899C70.1974 21.1529 70.2318 23.3699 70.3382 23.4043C71.8688 23.9019 71.8688 23.9019 73.0837 24.2485C73.0654 25.2972 72.9713 26.3433 72.8023 27.3785C71.5839 27.3304 68.8418 27.2927 66.968 27.2927C64.2979 27.2927 63.2786 27.3853 61.7789 27.3853C61.5626 25.7243 61.5627 25.7243 61.3121 24.2485C62.1907 23.9053 62.1907 23.9053 63.2649 23.4489C63.3644 23.4077 63.4537 21.7638 63.4537 20.8269V14.035C63.4537 10.9875 62.9389 8.73952 59.7506 8.73952C58.6283 8.73952 57.3139 9.25432 56.1436 9.90982V19.8934C56.1436 21.1563 56.1848 23.2979 56.2843 23.4077C56.3838 23.5175 57.156 23.9053 58.6489 24.2519C58.6278 25.3057 58.513 26.3554 58.3057 27.3887C57.132 27.3441 54.7708 27.2961 52.897 27.2961C49.616 27.2961 46.6851 27.3922 46.6851 27.3887C46.4523 26.3565 46.2997 25.3078 46.2287 24.2519Z"
      fill="url(#paint1_linear_582_18057)"
    />
    <path
      d="M32.8503 19.4163L25.9315 23.3081L25.3035 23.6513L23.0075 24.9555C23.1001 25.937 23.1104 26.2665 23.2614 27.3887C23.2614 27.3887 24.5793 27.351 26.4051 27.3235L32.8503 20.0203V19.4163Z"
      fill="url(#paint2_linear_582_18057)"
    />
    <path
      d="M26.0238 22.5089L32.85 17.8415V17.3953L26.0994 18.8573V20.8307C26.1029 21.391 26.0777 21.9512 26.0238 22.5089Z"
      fill="url(#paint3_linear_582_18057)"
    />
    <path
      d="M32.8501 12.5801C32.8501 12.5527 32.8845 12.5286 32.8982 12.5012L23.8344 5.44852C23.5564 5.54119 23.275 5.63728 22.9867 5.74024C22.7216 6.68653 22.787 7.69492 23.172 8.59906C24.3904 8.73977 24.888 8.97314 26.0995 9.34722V10.2876L32.8501 12.6419V12.5801Z"
      fill="url(#paint4_linear_582_18057)"
    />
    <path
      d="M32.8509 14.1316L26.1003 11.1595V14.1796L32.8509 14.3547V14.1316Z"
      fill="url(#paint5_linear_582_18057)"
    />
    <path
      d="M32.8509 15.6823L26.1003 14.8998V18.1258L32.8509 15.9877V15.6823Z"
      fill="url(#paint6_linear_582_18057)"
    />
    <path
      d="M27.3149 7.33977L33.6091 11.4684L27.3286 7.32604L27.3149 7.33977Z"
      fill="url(#paint7_linear_582_18057)"
    />
    <path
      d="M39.4091 4.14795C38.8109 4.14759 38.2153 4.22723 37.6382 4.38475C35.579 4.94416 34.0209 6.44392 32.8026 8.12901C32.4802 6.86867 32.0731 5.63151 31.5843 4.42594L31.1312 4.19256L30.8327 4.04156C28.6021 4.17007 26.3988 4.59597 24.2811 5.30795L27.3389 7.3225L33.616 11.4683C34.8343 9.89647 36.1453 9.16203 37.0754 9.16203C37.3416 9.15464 37.6079 9.16956 37.8716 9.20665C38.9012 11.2658 38.9012 11.2658 39.7351 13.7986C41.2795 13.8363 41.2795 13.8363 42.8239 13.7986C42.9028 13.5378 42.9715 13.2666 43.0367 12.9921C43.6064 10.6378 43.7608 7.91966 43.7608 4.89611C42.3721 4.36849 40.8943 4.11443 39.4091 4.14795Z"
      fill="url(#paint8_linear_582_18057)"
    />
    <path
      d="M32.9909 23.4114C32.9428 22.8623 32.9085 22.3132 32.8879 21.7469L27.4757 27.2827C29.027 27.2827 28.6495 27.3101 29.5349 27.2827H29.5967C31.9784 27.2827 34.0205 27.317 35.6197 27.3616H35.9252V27.2827C36.0625 25.6559 36.0659 25.6285 36.1723 24.2317C34.8819 23.8748 35.0054 23.9811 32.9909 23.4114Z"
      fill="url(#paint9_linear_582_18057)"
    />
    <path
      d="M27.2465 27.3098H27.2739V27.2823L27.2465 27.3098Z"
      fill="url(#paint10_linear_582_18057)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_582_18057"
        x1="0"
        y1="16"
        x2="73.0837"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_582_18057"
        x1="0"
        y1="16"
        x2="73.0837"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_582_18057"
        x1="0"
        y1="16"
        x2="73.0837"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_582_18057"
        x1="0"
        y1="16"
        x2="73.0837"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_582_18057"
        x1="0"
        y1="16"
        x2="73.0837"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_582_18057"
        x1="0"
        y1="16"
        x2="73.0837"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_582_18057"
        x1="0"
        y1="16"
        x2="73.0837"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_582_18057"
        x1="0"
        y1="16"
        x2="73.0837"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_582_18057"
        x1="0"
        y1="16"
        x2="73.0837"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_582_18057"
        x1="0"
        y1="16"
        x2="73.0837"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_582_18057"
        x1="0"
        y1="16"
        x2="73.0837"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
    </defs>
  </svg>
);

export default asapCrnLogoMobile;
